<mat-slide-toggle
  class="m-b-16 d-block"
  [checked]="isPopupEnabled"
  (change)="onPopupEnabledChange($event)"
>
  Enable Login Popup
</mat-slide-toggle>

<div class="m-b-16">
  <h4>Popup Title</h4>
  <mat-form-field class="w-full" appearance="outline">
    <input matInput [(ngModel)]="popupTitle" placeholder="Enter popup title here..." />
    <mat-hint>The title displayed at the top of the popup dialog.</mat-hint>
  </mat-form-field>
</div>

<div class="m-b-16">
  <h4>Popup Message Content</h4>
  <p class="text-muted">
    This message will be displayed when users log in. They can dismiss it or minimize it to a marker
    on the right side.
  </p>
</div>

<quill-editor
  placeholder="Enter popup message here..."
  [(ngModel)]="htmlContent"
  [modules]="quillModules"
  [styles]="{ height: '200px' }"
></quill-editor>
<button mat-raised-button class="m-t-16 control" color="accent" (click)="save()">Save</button>
